import React, { useState, useEffect } from 'react';
import {
  crearProveedor,
  obtenerProveedores,
  actualizarProveedor,
  eliminarProveedor
} from '../../services/proveedores';
import {
  Button,
  Table,
  Modal,
  Form,
  Input,
  message,
  Popconfirm
} from 'antd';
import Layouts from '../../components/Layouts';

const Proveedores = () => {
  const [proveedores, setProveedores] = useState([]);
  const [loading, setLoading] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [editingProveedor, setEditingProveedor] = useState(null);
  const [form] = Form.useForm();

  const fetchProveedores = async () => {
    try {
      setLoading(true);
      const data = await obtenerProveedores();
      setProveedores(data);
    } catch (error) {
      message.error('Error al cargar proveedores');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchProveedores();
  }, []);

  const handleCreate = () => {
    setEditingProveedor(null);
    form.resetFields();
    setModalVisible(true);
  };

  const handleEdit = (record) => {
    setEditingProveedor(record);
    form.setFieldsValue(record);
    setModalVisible(true);
  };

  const handleDelete = async (id) => {
    try {
      await eliminarProveedor(id);
      message.success('Proveedor eliminado exitosamente');
      fetchProveedores();
    } catch (error) {
      message.error('Error al eliminar proveedor');
    }
  };

  const handleSubmit = async (values) => {
    try {
      if (editingProveedor) {
        await actualizarProveedor(editingProveedor.id, values);
        message.success('Proveedor actualizado exitosamente');
      } else {
        await crearProveedor(values);
        message.success('Proveedor creado exitosamente');
      }
      setModalVisible(false);
      fetchProveedores();
    } catch (error) {
      message.error('Error al guardar proveedor');
    }
  };

  const columns = [
    {
      title: 'Nombre',
      dataIndex: 'nombre',
      key: 'nombre',
    },
    {
      title: 'Documento',
      dataIndex: 'documento',
      key: 'documento',
    },
    {
      title: 'Acciones',
      key: 'acciones',
      render: (_, record) => (
        <>
          <Button type="link" onClick={() => handleEdit(record)}>
            Editar
          </Button>
          <Popconfirm
            title="¿Estás seguro de eliminar este proveedor?"
            onConfirm={() => handleDelete(record.id)}
            okText="Sí"
            cancelText="No"
          >
            <Button type="link" danger>
              Eliminar
            </Button>
          </Popconfirm>
        </>
      ),
    },
  ];

  return (
    <Layouts>
    <div style={{ padding: '24px' }}>
      <Button
        type="primary"
        onClick={handleCreate}
        style={{ marginBottom: '16px' }}
      >
        Crear Proveedor
      </Button>

      <Table
        columns={columns}
        dataSource={proveedores}
        loading={loading}
        rowKey="id"
      />

      <Modal
        title={editingProveedor ? 'Editar Proveedor' : 'Crear Proveedor'}
        open={modalVisible}
        onCancel={() => setModalVisible(false)}
        footer={null}
      >
        <Form
          form={form}
          onFinish={handleSubmit}
          layout="vertical"
        >
          <Form.Item
            name="nombre"
            label="Nombre"
            rules={[{ required: true, message: 'Por favor ingrese el nombre' }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="documento"
            label="Documento"
            rules={[{ required: true, message: 'Por favor ingrese el documento' }]}
          >
            <Input />
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit">
              {editingProveedor ? 'Actualizar' : 'Crear'}
            </Button>
          </Form.Item>
        </Form>
      </Modal>
    </div>
    </Layouts>
  );
};

export default Proveedores;

